import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VerbrauchstypPipe } from '../../../bdo/pipes/verbrauchstyp.pipe';

@Component({
  selector: 'bdo-meterreading-info',
  templateUrl: './meterreading-info.component.html',
  standalone: false
})
export class MeterreadingInfoComponent implements OnInit{
  @Input() division: string = '';
  public divisionPicture: string = '';
  public divisionTranslated: string = '';

  constructor(
    public translateService: TranslateService,
    private verbrauchstypPipe: VerbrauchstypPipe
  ) { }

  ngOnInit() {
    if (this.division) {
      const divisionTranslated = this.verbrauchstypPipe.transform(this.division);
      this.divisionPicture = divisionTranslated;
      this.divisionTranslated = divisionTranslated;
    } else {
      this.divisionPicture = 'strom';
    }
  }
}
